import * as geom from "js/core/utilities/geom";
import { BaseElement } from "js/elements/base/BaseElement";
import { Dashboard } from "js/elements/elements/Dashboard";
import { BulletPoints } from "js/elements/elements/TextGrid";
import { Headline } from "js/elements/elements/Headline";
import { ContentElement } from "js/elements/base/ContentElement";
import { Rectangle } from "js/elements/elements/primitives/Rectangle";
import { Ellipse } from "js/elements/elements/primitives/Ellipse";

export class AuthoringCanvas extends BaseElement {
    getCanvasMargins() {
        return { left: 0, top: 0, right: 0, bottom: 0 };
    }

    _build() {
        if (!this.model.elements) {
            this.model.elements = [];
            return;
        }

        this.model.elements.forEach(elementModel => {
            this.addElement(elementModel.id, () => AuthoringElement, {
                model: elementModel
            });
        });
    }

    _calcProps(props, options) {
        const { size, children } = props;

        Object.values(this.elements).forEach(element => {
            const { x, y, width, height } = element.model;
            const elementIndex = this.model.elements.findIndex(({ id }) => id === element.model.id);

            const elementProps = children.setProps(element, new geom.Size(width, height));
            elementProps.bounds = new geom.Rect(x, y, width, height);
            elementProps.layer = -elementIndex;
        });

        return { size };
    }
}

class AuthoringElement extends BaseElement {
    getElementFactory() {
        const elementType = this.model.type;
        if (elementType === "Dashboard") {
            return () => Dashboard;
        } else if (elementType === "BulletPoints") {
            return () => BulletPoints;
        } else if (elementType === "Headline") {
            return () => Headline;
        } else if (elementType === "Rectangle") {
            return () => Rectangle;
        } else if (elementType === "Ellipse") {
            return () => Ellipse;
        } else if (elementType === "ContentElement") {
            return () => ContentElement;
        } else {
            throw new Error(`Unknown element type ${elementType}`);
        }
    }

    _build() {
        this.element = this.addElement("element", this.getElementFactory(), {
            model: this.model.element,
            canSelect: true
        });
    }

    _calcProps(props, options) {
        const { size, children } = props;

        const elementProps = children.setProps(this.element, size);
        elementProps.bounds = new geom.Rect(0, 0, size);

        return { size };
    }
}

export const elements = {
    AuthoringCanvas
};

